export const EXCMNOTE_DELETE_RESET = 'EXCMNOTE_DELETE_RESET'
export const EXCMNOTE_DELETE_SET_ERROR = 'EXCMNOTE_DELETE_SET_ERROR'
export const EXCMNOTE_DELETE_SET_DELETED = 'EXCMNOTE_DELETE_SET_DELETED'
export const EXCMNOTE_DELETE_TOGGLE_LOADING = 'EXCMNOTE_DELETE_TOGGLE_LOADING'
